import React from 'react';

import { SectionConnectionWrapper, ButtonWrapper } from './styled';

interface IProps {
  contentData: any;
}

const SectionConnection = ({ contentData }: IProps) => (
  <SectionConnectionWrapper>
    <p>Conéctate a tu examen:</p>
    <ButtonWrapper target="_black" href={contentData.idZoom}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 8.40002V13.8C5.006 15.02 5.953 16.005 7.115 16H14.615C14.827 16 14.999 15.822 15 15.6V10.2C14.994 8.98002 14.047 7.99502 12.884 8.00002H5.384C5.173 8.00002 5.001 8.17802 5 8.40002ZM15 10.509L18.467 8.13502C18.769 7.90502 19 7.95802 19 8.38502V15.624C19 16.104 18.712 16.049 18.467 15.874L15 13.5V10.509Z"
            fill="#5B36F2"
          />
        </g>
      </svg>
      <span>Unirme zoom</span>
    </ButtonWrapper>
  </SectionConnectionWrapper>
);

export default SectionConnection;
